/**
 * Text similarity utilities for proposal text analysis and harvest deduplication.
 */

/**
 * Tokenizes text into lowercase normalized words (alphanumeric, length >= 3)
 */
export function tokenize(text: string): string[] {
  if (!text) return [];
  return text
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, " ")
    .split(/\s+/)
    .filter((w) => w.length >= 3);
}

/**
 * Calculates token overlap ratio between two texts (0.0 to 1.0)
 */
export function calculateTextSimilarity(textA: string, textB: string): number {
  const tokensA = new Set(tokenize(textA));
  if (tokensA.size === 0) return 0;

  const tokensB = new Set(tokenize(textB));
  if (tokensB.size === 0) return 0;

  let intersectionCount = 0;
  for (const token of tokensA) {
    if (tokensB.has(token)) {
      intersectionCount++;
    }
  }

  const minSize = Math.min(tokensA.size, tokensB.size);
  if (minSize === 0) return 0;

  return Number((intersectionCount / minSize).toFixed(4));
}
